export default __webpack_public_path__ + "static/media/search-icon.18bd7926.svg";